var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_code"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "code"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_code"]
                            },
                            model: {
                              value: _vm.model.code,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "code", $$v)
                              },
                              expression: "model.code"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "name"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_name"]
                            },
                            model: {
                              value: _vm.model.name,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "name", $$v)
                              },
                              expression: "model.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_user_app"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "app"
                          }
                        },
                        [
                          _c("a-select", {
                            attrs: {
                              options: _vm.appList,
                              disabled: _vm.isDisabled
                            },
                            on: { change: _vm.handlerApp },
                            model: {
                              value: _vm.model.app,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "app", $$v)
                              },
                              expression: "model.app"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_price"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "price"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_price"]
                            },
                            model: {
                              value: _vm.model.price,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "price", $$v)
                              },
                              expression: "model.price"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_market_price"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "marketPrice"
                          }
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_market_price"]
                            },
                            model: {
                              value: _vm.model.marketPrice,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "marketPrice", $$v)
                              },
                              expression: "model.marketPrice"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_vendor"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "supplier"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              on: { change: _vm.handlerChange },
                              model: {
                                value: _vm.model.supplier,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "supplier", $$v)
                                },
                                expression: "model.supplier"
                              }
                            },
                            _vm._l(_vm.vendorMap, function(item, index) {
                              return _c(
                                "a-select-option",
                                {
                                  key: item.key,
                                  attrs: { value: item.key, label: item.value }
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.value) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_merchant_name"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol,
                            prop: "businessName"
                          }
                        },
                        [
                          _c(
                            "a-select",
                            {
                              on: { change: _vm.handlerChangeBusinessName },
                              model: {
                                value: _vm.model.businessName,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "businessName", $$v)
                                },
                                expression: "model.businessName"
                              }
                            },
                            _vm._l(_vm.businessMap, function(v, k) {
                              return _c(
                                "a-select-option",
                                { key: k, attrs: { value: k, label: v } },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(v) +
                                      "\n                "
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_limit"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-switch", {
                            on: { change: _vm.handlerLimited },
                            model: {
                              value: _vm.isSwitch,
                              callback: function($$v) {
                                _vm.isSwitch = $$v
                              },
                              expression: "isSwitch"
                            }
                          }),
                          _c("a-input", {
                            staticStyle: {
                              width: "80%",
                              "margin-left": "10px"
                            },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseInput"] +
                                _vm.language["gift_product_limit"],
                              disabled: _vm.isLimitDisabled
                            },
                            on: { change: _vm.limitedChange },
                            model: {
                              value: _vm.model.limited,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "limited", $$v)
                              },
                              expression: "model.limited"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticStyle: { "margin-left": "20px" },
                          attrs: {
                            label: _vm.language["gift_up_down"],
                            labelCol: _vm.labelCol3
                          }
                        },
                        [
                          _c("j-switch", {
                            on: { change: _vm.changeSwitch },
                            model: {
                              value: _vm.model.status,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "status", $$v)
                              },
                              expression: "model.status"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_virtual"],
                            labelCol: _vm.labelCol3,
                            prop: "virtual"
                          }
                        },
                        [
                          _c("j-switch", {
                            on: { change: _vm.virtualChange },
                            model: {
                              value: _vm.model.virtual,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "virtual", $$v)
                              },
                              expression: "model.virtual"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_link"],
                            labelCol: _vm.labelCol,
                            wrapperCol: _vm.wrapperCol
                          }
                        },
                        [
                          _c("a-input", {
                            staticStyle: { width: "75%" },
                            attrs: {
                              placeholder:
                                _vm.language["common.pleaseChoose"] +
                                _vm.language["gift_product_link"],
                              disabled: ""
                            },
                            model: {
                              value: _vm.productCode,
                              callback: function($$v) {
                                _vm.productCode = $$v
                              },
                              expression: "productCode"
                            }
                          }),
                          _c(
                            "a-button",
                            {
                              staticStyle: { left: "2%" },
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSelect }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.language["common.selectButton"])
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_thumbnail"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "thumbnail"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: false,
                              "biz-path": _vm.uploadSource,
                              maxSize: 200,
                              "customer-before-upload": _vm.beforeUpload,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.thumbnail,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "thumbnail", $$v)
                              },
                              expression: "model.thumbnail"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_img"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "images"
                          }
                        },
                        [
                          _c("j-image-upload", {
                            staticClass: "avatar-uploader",
                            attrs: {
                              text: _vm.language["common.uploadButton"],
                              "upload-source": _vm.uploadSource,
                              isMultiple: true,
                              "biz-path": _vm.uploadSource,
                              maxSize: 200,
                              "customer-before-upload": _vm.beforeUpload,
                              disabled: _vm.disableSubmit
                            },
                            model: {
                              value: _vm.model.images,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "images", $$v)
                              },
                              expression: "model.images"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          attrs: {
                            label: _vm.language["gift_product_tag"],
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            prop: "value"
                          }
                        },
                        _vm._l(_vm.tagList, function(item) {
                          return _c(
                            "div",
                            [
                              _c("span", [_vm._v(_vm._s(item.title))]),
                              _c("j-checkbox", {
                                staticStyle: { "margin-left": "20px" },
                                attrs: { options: item.tags },
                                on: {
                                  change: function($event) {
                                    return _vm.handleCheckBox(
                                      item.title,
                                      item.value
                                    )
                                  }
                                },
                                model: {
                                  value: item.value,
                                  callback: function($$v) {
                                    _vm.$set(item, "value", $$v)
                                  },
                                  expression: "item.value"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      )
                    ],
                    1
                  ),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["weight"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "weight"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: {
                                  width: "90%",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["weight"]
                                },
                                model: {
                                  value: _vm.model.weight,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "weight", $$v)
                                  },
                                  expression: "model.weight"
                                }
                              }),
                              _c("span", [_vm._v("g")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["length"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "length"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: {
                                  width: "90%",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["length"]
                                },
                                model: {
                                  value: _vm.model.length,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "length", $$v)
                                  },
                                  expression: "model.length"
                                }
                              }),
                              _c("span", [_vm._v("cm")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["width"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "width"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: {
                                  width: "90%",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["width"]
                                },
                                model: {
                                  value: _vm.model.width,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "width", $$v)
                                  },
                                  expression: "model.width"
                                }
                              }),
                              _c("span", [_vm._v("cm")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["hight"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "height"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: {
                                  width: "90%",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["hight"]
                                },
                                model: {
                                  value: _vm.model.height,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "height", $$v)
                                  },
                                  expression: "model.height"
                                }
                              }),
                              _c("span", [_vm._v("cm")])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["fd.effdate"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "validityPeriod"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["fd.effdate"],
                                  "auto-size": { minRows: 5, maxRows: 8 }
                                },
                                model: {
                                  value: _vm.model.validityPeriod,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "validityPeriod", $$v)
                                  },
                                  expression: "model.validityPeriod"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["gift_product_place"],
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "origin"
                              }
                            },
                            [
                              _c("a-input", {
                                staticStyle: {
                                  width: "90%",
                                  "margin-right": "5px"
                                },
                                attrs: {
                                  placeholder:
                                    _vm.language["common.pleaseInput"] +
                                    _vm.language["gift_product_place"]
                                },
                                model: {
                                  value: _vm.model.origin,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "origin", $$v)
                                  },
                                  expression: "model.origin"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("a-col", { attrs: { span: 12 } }),
                  _vm.notVirtualFlag
                    ? _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: _vm.language["gift_product_ingredient"],
                                labelCol: _vm.labelCol2,
                                wrapperCol: _vm.wrapperCol2,
                                prop: "ingredient"
                              }
                            },
                            [
                              _c("j-editor", {
                                attrs: { plugins: _vm.JEitorPlugins },
                                model: {
                                  value: _vm.model.ingredient,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "ingredient", $$v)
                                  },
                                  expression: "model.ingredient"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "a-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "a-form-model-item",
                        {
                          staticClass: "j-field-content",
                          attrs: {
                            labelCol: _vm.labelCol2,
                            wrapperCol: _vm.wrapperCol2,
                            label: _vm.language["product_desc"],
                            prop: "description"
                          }
                        },
                        [
                          _c("j-editor", {
                            attrs: {
                              disabled: _vm.disableSubmit,
                              plugins: _vm.JEitorPlugins
                            },
                            model: {
                              value: _vm.model.description,
                              callback: function($$v) {
                                _vm.$set(_vm.model, "description", $$v)
                              },
                              expression: "model.description"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("gift-product-select-modal", {
            ref: "modalSelect",
            on: { ok: _vm.modalSelect }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }